import ajax from "@/libs/Ajax";

const NAME_SPACE = "/TaskController";
export default {
  query(params) {
    return ajax.get(`${NAME_SPACE}/query`, {params})
  },
  save(data) {
    return ajax.post(`${NAME_SPACE}/save`, data)
  },
  get(uuid) {
    return ajax.get(`${NAME_SPACE}/get/${uuid}`)
  },
  delete(uuid) {
    return ajax.delete(`${NAME_SPACE}/delete/${uuid}`)
  },
  start(uuid) {
    return ajax.get(`${NAME_SPACE}/start/${uuid}`)
  },
  once(uuid) {
    return ajax.get(`${NAME_SPACE}/once/${uuid}`)
  },
  multiStart(data) {
    return ajax.post(`${NAME_SPACE}/multiStart`, data)
  },
  multiStop(data) {
    return ajax.post(`${NAME_SPACE}/multiStop`, data)
  },
  stop(uuid) {
    return ajax.get(`${NAME_SPACE}/stop/${uuid}`)
  },
  getTaskList(uuid) {
    return ajax.get(`${NAME_SPACE}/getTaskList`)
  },

};
